export default __webpack_public_path__ + "static/media/ru-ce.9ef641c9.svg";